import React, { Component } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import classnames from 'classnames';
import { UncontrolledTooltip } from 'reactstrap';
import PropTypes from 'prop-types';
import { v4 as uuid } from 'uuid';
import { isA11yClick } from '../../util/accessabilityUtils';

export class IconWithTooltip extends Component {
  constructor(props) {
    super(props);
    this.handleClick = this.handleClick.bind(this);
    this.resolveClassname = this.resolveClassname.bind(this);
    this.id = `i${uuid()}`;
  }

  handleClick(e) {
    const { handleClick } = this.props;
    if (handleClick && isA11yClick(e)) {
      handleClick(e);
    }
  }

  resolveClassname() {
    const {
      handleClick, className,
    } = this.props;

    const cn = classnames({
      'align-middle': true,
      'haz-pointer-cursor': Boolean(handleClick),
    });

    if (className) {
      return `${cn} ${className}`;
    }

    return cn;
  }

  render() {
    const {
      ariaLabel, tooltip, icon, size,
    } = this.props;
    return (
      <div>
        <FontAwesomeIcon
          /* tabIndex={handleClick ? 0 : -1} */
          tabIndex={0}
          id={this.id}
          aria-label={`${ariaLabel}, Click for More Information`}
          aria-hidden="false"
          className={this.resolveClassname()}
          icon={icon}
          onClick={this.handleClick}
          onKeyDown={this.handleClick}
          size={size}
        />
        <span id={`${this.id}tooltip`} aria-hidden="true" style={{ display: 'none' }}>{`${ariaLabel} Help Information, Click to Expand`}</span>
        <UncontrolledTooltip target={this.id}>{tooltip}</UncontrolledTooltip>
      </div>
    );
  }
}

IconWithTooltip.propTypes = {
// eslint-disable-next-line react/require-default-props
  handleClick: PropTypes.func,
  ariaLabel: PropTypes.string.isRequired,
  tooltip: PropTypes.string.isRequired,
  icon: PropTypes.string.isRequired,
  className: PropTypes.string,
  size: PropTypes.string,
};

IconWithTooltip.defaultProps = {
  className: '',
  size: '1x',
};
